import { tv } from "../../variants/tv.js";
const drawer = tv({
    slots: {
        overlaySlot: 'fixed inset-0 bg-neutral-13/50',
        contentSlot: 'fixed flex h-fit flex-col bg-neutral-1 shadow-overlay-lg outline-hidden',
        headingTextSlot: 'font-semibold text-neutral-13',
        closeButtonSlot: '',
        headingSlot: 'flex w-full flex-row items-center justify-between px-4',
        headingSlotLeft: 'flex flex-1 flex-row items-center',
        headingRightNodeSlot: 'mr-2',
        headingIconSlot: 'mr-2 text-neutral-13',
        bodySlot: 'py-4',
        footerSlot: 'shrink-0',
        popupScrollWrapperSlot: '',
        scrollAreaSlot: '',
        handlePositionSlot: 'absolute top-0 left-1/2 -translate-x-6',
        handleSlot: 'absolute top-3 left-0 -mb-3 h-1 w-12! cursor-grab rounded-full bg-primary-5 active:cursor-grabbing'
    },
    variants: {
        size: {
            sm: {
                contentSlot: 'w-full max-w-96'
            },
            md: {
                contentSlot: 'w-full max-w-160'
            },
            lg: {
                contentSlot: 'w-full max-w-240'
            },
            xl: {
                contentSlot: 'w-full max-w-320'
            },
            full: {
                contentSlot: 'w-full'
            }
        },
        showDragHandle: {
            true: {
                contentSlot: 'pt-4',
                headingSlot: 'pt-0'
            },
            false: {
                headingSlot: 'pt-4'
            }
        },
        direction: {
            bottom: {
                contentSlot: 'bottom-0 left-1/2 -translate-x-1/2 rounded-t-2xl'
            },
            right: {
                contentSlot: 'right-0 -translate-x-4 rounded-2xl after:hidden'
            },
            left: {
                contentSlot: 'left-0 translate-x-4 rounded-2xl after:hidden'
            },
            top: {
                contentSlot: 'top-0 left-1/2 -translate-x-1/2 translate-y-4 rounded-2xl after:hidden'
            }
        },
        customFooter: {
            true: {
                contentSlot: 'pb-0'
            },
            false: {}
        },
        customBody: {
            true: {
                bodySlot: 'py-0'
            },
            false: {}
        },
        customHeader: {
            true: {
                contentSlot: 'pt-0',
                headingSlot: 'px-0',
                closeButtonSlot: 'absolute top-2 right-2'
            }
        },
        scroll: {
            none: {},
            body: {
                contentSlot: 'h-full max-h-[calc(100dvh-40px)]',
                scrollAreaSlot: 'min-h-0 flex-1'
            }
        },
        stickyFooter: {
            true: {
                footerSlot: 'sticky right-0 bottom-0 left-0'
            }
        },
        showCloseButton: {
            true: {
                bodySlot: 'pt-2'
            }
        },
        useSnapping: {
            true: {}
        },
        hasHeadingText: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            showCloseButton: true,
            customBody: true,
            class: {
                bodySlot: 'pt-0'
            }
        },
        {
            useSnapping: true,
            direction: 'bottom',
            class: {
                contentSlot: 'mx-[-1px] h-full max-h-[97%]'
            }
        },
        {
            scroll: 'body',
            hasHeadingText: true,
            class: {
                headingSlot: 'border-b-1 border-neutral-6/50'
            }
        }
    ],
    defaultVariants: {
        direction: 'bottom',
        size: 'full',
        scroll: 'none',
        stickyFooter: false
    }
});
const drawerSlots = drawer.slots;
const drawerVariants = drawer;
const drawerSizes = Object.keys(drawerVariants.variants.size);
export { drawer, drawerSizes, drawerSlots, drawerVariants };
